function hexToRGB(hex) {
  // Check for shorthand notation (e.g., #abc)
  const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  hex = hex.replace(shorthandRegex, function (_, r, g, b) {
    return r + r + g + g + b + b;
  });

  // Parse the hex values into RGB
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? {
      r: parseInt(result[1], 16),
      g: parseInt(result[2], 16),
      b: parseInt(result[3], 16),
    }
    : null;
}

export default function getContrastText(hexColor) {
  const rgb = hexToRGB(hexColor);
  if (!rgb) {
    return '#fff'
  }

  const luminance = (r, g, b) => (r * 0.299 + g * 0.587 + b * 0.114);
  const textColor = luminance(rgb.r, rgb.g, rgb.b) > 186 ? '#000000' : '#FFFFFF';

  return textColor;
}
